import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

@Component({
    selector: 'app-courses-grid-style-two-columns-three-page',
    templateUrl: './courses-grid-style-two-columns-three-page.component.html',
    styleUrls: ['./courses-grid-style-two-columns-three-page.component.scss']
})
export class CoursesGridStyleTwoColumnsThreePageComponent implements OnInit {

    isToggled = false;
	
    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {}

}